var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUcropit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_695",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 223.253,
    height: 59.053,
    viewBox: "0 0 223.3 59.1",
    style: {
      enableBackground: "new 0 0 223.3 59.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFCD00;}\n\t.st2{fill:#106744;}\n\t.st3{fill:#106744;stroke:#106744;stroke-width:2.799;}\n\t.st4{fill:#54AD47;}\n\t.st5{fill:#001423;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 15.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -11.6236 29.3478)",
    className: "st0",
    width: 26.8,
    height: 26.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2255",
    className: "st1",
    d: "M44.8,29L31.4,41.8l7.1,7L59.6,29L29.5,0L0,28.7l29.8,28.2l8.5-8.2l-7-6.9l-1.5,1.1L15.3,29 l14.4-14.3L44.8,29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2256",
    className: "st2",
    d: "M9.1,20c20.6-0.7,25.2,25.2,19.4,39.1C41.2,38.2,26.3,3.9,9.1,20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2257",
    className: "st3",
    d: "M31.6,24.3c1.3,2.7,2.3,5.6,2.9,8.5c2.6-6.4,5-9.4,13.7-12.4C40.5,17.6,36.8,18.4,31.6,24.3z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2258",
    className: "st4",
    d: "M13.4,54.2c9.1-5.2,29.6-4.8,37.3,0C41.5,47,23.4,46.8,13.4,54.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2259",
    className: "st5",
    d: "M86.9,19.5v12.6c0,1.7-0.4,3.4-1.3,4.9c-0.8,1.3-2,2.4-3.4,3.1c-1.5,0.7-3.2,1.1-4.9,1.1 c-1.7,0-3.4-0.3-4.9-1.1C71,39.4,69.9,38.3,69,37c-0.8-1.5-1.3-3.2-1.2-4.9V19.5h5.4l0,11.6c-0.1,1.3,0.3,2.6,1.1,3.7 c0.8,0.8,1.9,1.3,3,1.2c1.1,0,2.2-0.4,3-1.2c0.9-1,1.3-2.3,1.2-3.7V19.5H86.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2260",
    className: "st5",
    d: "M102.6,19c1.3,0,2.6,0.2,3.8,0.8c0.8,0.4,1.6,0.9,2.4,1.5v4.9c-0.8-0.5-1.6-1-2.5-1.3 c-1.1-0.4-2.2-0.6-3.3-0.5c-1,0-2.1,0.3-3,0.8c-0.9,0.5-1.6,1.3-2.1,2.1c-0.5,0.9-0.8,2-0.8,3.1c-0.1,3.2,2.3,5.8,5.5,5.9 c0.1,0,0.3,0,0.4,0c1.1,0,2.2-0.1,3.3-0.5c0.9-0.3,1.7-0.8,2.5-1.3v4.8c-0.7,0.6-1.5,1.1-2.4,1.5c-1.2,0.5-2.5,0.7-3.8,0.7 c-2,0-4-0.5-5.7-1.5c-1.6-1-3-2.4-3.9-4.1c-0.9-1.7-1.4-3.6-1.4-5.5c0-4.4,2.6-8.4,6.7-10.3C99.6,19.3,101.1,19,102.6,19z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2261",
    className: "st5",
    d: "M126.9,25.5c-0.9-0.5-1.8-0.8-2.8-0.8c-1.1,0-2.2,0.4-3.1,1.2c-0.9,0.9-1.6,1.8-2.1,2.9v11.8 h-5.3V19.5h5.3v4c0.7-1.2,1.5-2.2,2.6-3.1c0.9-0.8,2.1-1.3,3.4-1.3c0.7,0,1.4,0.1,2.1,0.4L126.9,25.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2262",
    className: "st5",
    d: "M140.8,19c2,0,3.9,0.5,5.6,1.5c1.7,1,3.1,2.3,4.1,4c2.1,3.5,2.1,7.8,0,11.3 c-1,1.7-2.4,3-4.1,4c-1.7,1-3.7,1.5-5.6,1.5c-2,0-3.9-0.5-5.6-1.5c-1.7-1-3.1-2.4-4.1-4c-2.1-3.5-2.1-7.8,0-11.3 c1-1.7,2.4-3.1,4.1-4C136.9,19.5,138.8,19,140.8,19z M140.8,24.1c-1,0-1.9,0.2-2.8,0.7c-0.9,0.5-1.6,1.2-2.1,2c-1,2.1-1,4.5,0,6.5 c0.5,0.9,1.2,1.6,2.1,2c1.8,0.9,3.8,0.9,5.6,0c0.9-0.5,1.6-1.2,2.1-2c1.1-2,1.1-4.5,0-6.5c-0.5-0.9-1.2-1.6-2.1-2 C142.7,24.4,141.8,24.1,140.8,24.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2263",
    className: "st5",
    d: "M169.2,19c1.6,0,3.2,0.4,4.6,1.3c1.5,0.9,2.7,2.2,3.5,3.7c0.9,1.8,1.4,3.9,1.3,5.9 c0.1,2.1-0.4,4.2-1.3,6.1c-0.8,1.6-2,3-3.6,3.9c-1.5,0.9-3.2,1.4-4.9,1.3c-1.2,0-2.4-0.3-3.5-0.8c-1.1-0.5-2.1-1.3-2.9-2.2v12.4 h-5.3V19.5h5.3v3.6c0.6-1.2,1.6-2.2,2.7-2.9C166.3,19.4,167.8,18.9,169.2,19z M167.9,24.3c-0.9,0-1.9,0.3-2.7,0.8 c-0.9,0.5-1.6,1.2-2.1,2c-0.5,1-0.8,2.1-0.7,3.2v3.1c0.7,0.8,1.5,1.4,2.4,2c0.9,0.5,1.9,0.8,2.9,0.8c1,0,2-0.3,2.8-0.9 c0.8-0.6,1.5-1.4,1.9-2.3c0.4-0.9,0.7-2,0.7-3c0-1.5-0.5-2.9-1.5-4C170.8,24.8,169.4,24.2,167.9,24.3L167.9,24.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2264",
    className: "st5",
    d: "M186.3,34.7c1.8,0,3.3,1.5,3.3,3.3c0,0.9-0.4,1.8-1,2.4c-0.6,0.6-1.5,1-2.3,1 c-1.8,0-3.3-1.4-3.3-3.2c0,0,0-0.1,0-0.1c0-0.9,0.3-1.7,1-2.3C184.5,35.1,185.4,34.7,186.3,34.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2265",
    className: "st5",
    d: "M199.7,8.5c1,0,1.9,0.4,2.6,1.1c0.7,0.6,1.1,1.6,1.1,2.5c0,1-0.4,1.9-1.1,2.5 c-1.4,1.4-3.7,1.5-5.1,0c-0.7-0.7-1.1-1.6-1.1-2.6c0-0.9,0.4-1.9,1-2.5C197.8,8.9,198.8,8.5,199.7,8.5z M202.8,19.5v21.1h-5.3V19.5 L202.8,19.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2266",
    className: "st5",
    d: "M217.2,13.4v6.2h5.9v4.4h-5.9v9.1c0,0.8,0.2,1.6,0.6,2.3c0.5,0.6,1.2,0.8,2,0.8 c0.7,0,1.3-0.1,1.9-0.3c0.5-0.2,1.1-0.4,1.5-0.7v4.2c-0.6,0.6-1.3,1-2,1.3c-0.9,0.4-2,0.6-3,0.5c-1.7,0.1-3.4-0.6-4.6-1.8 c-1.2-1.4-1.9-3.2-1.8-5V24h-3.8v-4.4h3.8v-6.2L217.2,13.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUcropit);
export default __webpack_public_path__ + "static/media/logoUcropit.aa56c283a2dbecdd1a65ca72a9b9aa0d.svg";
export { ForwardRef as ReactComponent };